import React, {useState, useEffect, useRef} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Sidebar} from "primereact/sidebar";

import _FM_CurrencyListComponent from "../components/_FM_currency/_FM_CurrencyListComponent";
import _FM_CurrencyFormComponent from "../components/_FM_currency/_FM_CurrencyFormComponent";
import _FM_CurrencyShowComponent from "../components/_FM_currency/_FM_CurrencyShowComponent";
import HelpComponent from "../components/HelpComponent";

const _FM_CurrencyPage = (props) => {

  const {t, i18n} = props;
  const navigate = useNavigate();
  const {id,action, entity} = useParams();

  useEffect(() => {
    document.title = t('currencies') + ' - ' + process.env.REACT_APP_TITLE;
    window.App.help('/currency')
  }, []);

  return (
    <div className="_FM_CurrencyPage p-component p-m-lg-4">
      <HelpComponent type={"site"} position={"TOP_OF_THE_PAGE"} url={"/currency"}/>
      <Panel>
        <_FM_CurrencyListComponent />
      </Panel>
      <Sidebar position="right" visible={!entity && (action === 'create' || action === 'update')} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate('/currency');
               }}>
        <_FM_CurrencyFormComponent />
      </Sidebar>
      <Sidebar position="right" visible={action === 'read'} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate('/currency');
               }}>
        <_FM_CurrencyShowComponent />
      </Sidebar>
    </div>
  )
}
export default withTranslation('common')(_FM_CurrencyPage);
